<p-dialog
  [header]="'contributions.selectTripModal.subtitle' | transloco"
  [(visible)]="modalService.visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '700px', maxHeight: '85vh' }"
  [contentStyle]="{ overflow: 'auto', paddingBottom: '1.5rem' }"
  styleClass="select-trip-modal"
  (onHide)="onClose()"
>
  <div class="flex flex-col gap-4">
    <!-- Search Input -->
    <p-iconfield class="w-full">
      <p-inputicon>
        <lucide-icon
          [img]="searchIcon"
          class="h-4 w-4 text-gray-400"
        ></lucide-icon>
      </p-inputicon>
      <input
        type="text"
        pInputText
        class="w-full"
        [placeholder]="
          'contributions.selectTripModal.searchPlaceholder' | transloco
        "
        [ngModel]="modalService.searchTerm()"
        (ngModelChange)="modalService.searchTerm.set($event)"
      />
    </p-iconfield>

    <!-- Loading State -->
    @if (modalService.loading()) {
      <div class="flex items-center justify-center py-12">
        <p-progressSpinner
          strokeWidth="4"
          [style]="{ width: '50px', height: '50px' }"
        />
      </div>
    } @else {
      <!-- Empty State: No trips at all -->
      @if (hasNoTrips) {
        <div class="flex flex-col items-center py-12 text-center">
          <div
            class="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100"
          >
            <lucide-icon
              [img]="mapIcon"
              class="h-8 w-8 text-primary-600"
            ></lucide-icon>
          </div>
          <h3 class="mb-2 text-lg font-semibold text-gray-900">
            {{ "contributions.selectTripModal.emptyTitle" | transloco }}
          </h3>
          <p class="mb-6 max-w-sm text-gray-500">
            {{ "contributions.selectTripModal.emptyDescription" | transloco }}
          </p>
          <p-button
            [label]="'contributions.selectTripModal.createTrip' | transloco"
            icon="pi pi-plus"
            (onClick)="onCreateTrip()"
          />
          <div class="mt-8 flex items-start gap-2 rounded-lg bg-amber-50 p-4">
            <lucide-icon
              [img]="lightbulbIcon"
              class="h-5 w-5 flex-shrink-0 text-amber-600"
            ></lucide-icon>
            <p class="text-sm text-amber-800">
              {{ "contributions.selectTripModal.hint" | transloco }}
            </p>
          </div>
        </div>
      } @else {
        <!-- No search results -->
        @if (hasNoResults) {
          <div class="py-8 text-center text-gray-500">
            {{ "contributions.selectTripModal.noResults" | transloco }}
          </div>
        } @else {
          <!-- Ready Trips Section -->
          @if (modalService.readyTrips().length > 0) {
            <div>
              <h4
                class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500"
              >
                {{ "contributions.selectTripModal.sectionReady" | transloco }}
                ({{ modalService.readyTrips().length }})
              </h4>
              <div class="flex flex-col gap-3">
                @for (trip of modalService.readyTrips(); track trip.id) {
                  <app-trip-selection-card
                    [trip]="trip"
                    (selectTrip)="onSelectTrip($event)"
                    (finalizeTrip)="onFinalizeDraft($event)"
                  />
                }
              </div>
            </div>
          }

          <!-- Draft Trips Section -->
          @if (modalService.draftTrips().length > 0) {
            <div>
              <h4
                class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500"
              >
                {{ "contributions.selectTripModal.sectionDraft" | transloco }}
                ({{ modalService.draftTrips().length }})
              </h4>
              <div class="flex flex-col gap-3">
                @for (trip of modalService.draftTrips(); track trip.id) {
                  <app-trip-selection-card
                    [trip]="trip"
                    (selectTrip)="onSelectTrip($event)"
                    (finalizeTrip)="onFinalizeDraft($event)"
                  />
                }
              </div>
            </div>
          }
        }

        <!-- Info Card -->
        @if (!hasNoResults) {
          <div class="flex items-start gap-2 rounded-lg bg-primary-50 p-4">
            <lucide-icon
              [img]="lightbulbIcon"
              class="h-5 w-5 flex-shrink-0 text-primary-600"
            ></lucide-icon>
            <p class="text-sm text-primary-800">
              {{ infoMessage | transloco: infoMessageParams }}
            </p>
          </div>
        }
      }
    }
  </div>
</p-dialog>
